import { formatDollarAmount } from '@hero/hero-utils/currency';
import { getPerPlanLabel } from '@hero/hero-utils/membership';
const getSubscriptionFeeFormatted = (plan) => plan
    ? `${formatDollarAmount(plan.prepaid_amount || plan.monthly_fee, true)} / ${getPerPlanLabel(plan?.storefront_key)}`
    : '-';
export default getSubscriptionFeeFormatted;
